import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function RttIcon(props: IconProps) {
    return <Icon {...props} iconKey={"rtt"}/>
}
